import React from 'react';
import { BellIcon, MenuIcon } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { isV2PreviewEnabled } from '../../utils/featureFlags';

interface AdminNavbarProps {
  toggleSidebar: () => void;
}

// Get page name from admin route
const getAdminPageName = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  // segments[0] = 'admin', segments[1] = route

  const routeMap: { [key: string]: string } = {
    dashboard: 'Executive Dashboard',
    operations: 'Operations',
    brands: 'Brands Management',
    users: 'Users & Roles',
    promotions: 'Promotions Publisher',
    onboarding: 'Brand onboarding',
    catalog: 'Catalog',
    reconcile: 'Weekly Reconciliation',
  };

  const route = segments[1];
  return routeMap[route] || 'Admin';
};

const AdminNavbar: React.FC<AdminNavbarProps> = ({ toggleSidebar }) => {
  const location = useLocation();
  const { user } = useCurrentUser();
  const pageName = getAdminPageName(location.pathname);

  return (
    <header className="bg-white shadow-sm z-10 h-16">
      <div className="flex items-center justify-between h-full px-4">
        {/* Left side */}
        <div className="flex items-center gap-4">
          <button
            onClick={toggleSidebar}
            className="text-gray-600 focus:outline-none lg:hidden"
          >
            <MenuIcon size={24} />
          </button>

          {/* Page Title */}
          <div className="flex items-center gap-3">
            <h1 className="text-lg font-bold text-gray-900">{pageName}</h1>

            {/* Admin Badge */}
            <span className="px-2 py-0.5 text-xs font-semibold bg-orange-100 text-orange-700 rounded-full">
              Admin
            </span>
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-4">
          {/* Notifications — decorative bell, V2 preview surface (master plan Amendment 2026-07-09) */}
          {isV2PreviewEnabled(user) && (
            <div className="relative">
              <button className="flex items-center text-gray-600 focus:outline-none">
                <div className="h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-800 relative">
                  <BellIcon size={18} />
                  <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full"></span>
                </div>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminNavbar;
